module.exports = __webpack_public_path__ + "img/withe.544e7255.png";